import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import POS from "@/pages/POS";
import MenuManagement from "@/pages/MenuManagement";
import Categories from "@/pages/Categories";
import Tables from "@/pages/Tables";
import BillHistory from "@/pages/BillHistory";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Cashiers from "@/pages/Cashiers";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] text-[#9CA3AF]">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/pos" replace />;
  return children;
}

function Shell({ children, adminOnly }) {
  return (
    <Protected adminOnly={adminOnly}>
      <Layout>{children}</Layout>
    </Protected>
  );
}

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/pos" replace />} />
            <Route path="/pos" element={<Shell><POS /></Shell>} />
            <Route path="/history" element={<Shell><BillHistory /></Shell>} />
            <Route path="/tables" element={<Shell><Tables /></Shell>} />
            <Route path="/dashboard" element={<Shell adminOnly><Dashboard /></Shell>} />
            <Route path="/menu" element={<Shell adminOnly><MenuManagement /></Shell>} />
            <Route path="/categories" element={<Shell adminOnly><Categories /></Shell>} />
            <Route path="/cashiers" element={<Shell adminOnly><Cashiers /></Shell>} />
            <Route path="/settings" element={<Shell adminOnly><Settings /></Shell>} />
            <Route path="*" element={<Navigate to="/pos" replace />} />
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
